import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/app/(pages)/fs/@section7/page.tsx");
